import React, { useEffect } from 'react'
import AOS from 'aos';
import { FaChartLine, FaBolt, FaShieldAlt, FaLayerGroup } from 'react-icons/fa';
import 'aos/dist/aos.css';
const WhatWeDo = () => {
    useEffect(() => {
        AOS.init({
          // Global settings here...
        });
      }, []);
  return (
    <>
      <div id='engines' className='engines-section research-infrastructure section-grid px-5 md:px-16 lg:px-20 flex flex-col justify-center items-center bg-[#f1f1f1]'>
        <div className='w-full max-w-screen-min-screen'>
          <h1 className='text-primary-dark metro-semi uppercase mb-5' data-aos="fade-up" data-aos-duration="1000">/ Research Infrastructure</h1>
          <h1 data-aos="fade-up" data-aos-duration="1000" className='text-secondary section-headline domin mb-10 lg:mb-12'>QLab develops quantitative research systems for signal discovery, execution optimization, and portfolio risk engineering.</h1>
          <p data-aos="fade-up" data-aos-duration="1000" className='engines-intro text-[19px] lg:text-[22px] xl:text-[24px] text-secondary-light metro leading-relaxed'>Each engine addresses a specific role in the research stack while keeping strategy logic proprietary.</p>
        </div>
        <div data-aos="fade-up" data-aos-duration="1000" className='engine-grid infrastructure-grid grid w-full max-w-screen-min-screen grid-cols-1 md:grid-cols-2 justify-center items-start'>
          <div className='engine-item infrastructure-item flex items-start text-[21px] font-semibold leading-snug'>
            <FaChartLine className='text-[2.35rem] text-[#1FAFA0] mt-1 shrink-0' />
            <div>
              <h4>Signal Engine</h4>
              <p>Identifies statistical patterns in financial time series.</p>
            </div>
          </div>
          <div className='engine-item infrastructure-item flex items-start text-[21px] font-semibold leading-snug'>
            <FaBolt className='text-[2.35rem] text-[#1FAFA0] mt-1 shrink-0'/>
            <div>
              <h4>Execution Engine</h4>
              <p>Optimizes order execution and minimizes slippage.</p>
            </div>
          </div>
          <div className='engine-item infrastructure-item flex items-start text-[21px] font-semibold leading-snug'>
            <FaShieldAlt className='text-[2.35rem] text-[#1FAFA0] mt-1 shrink-0'/>
            <div>
              <h4>Risk Engine</h4>
              <p>Monitors portfolio exposure and drawdowns.</p>
            </div>
          </div>
          <div className='engine-item infrastructure-item flex items-start text-[21px] font-semibold leading-snug'>
            <FaLayerGroup className='text-[2.35rem] text-[#1FAFA0] mt-1 shrink-0'/>
            <div>
              <h4>Allocation Engine</h4>
              <p>Dynamically allocates capital across strategies.</p>
            </div>
          </div>
        </div>

        <div data-aos="fade-up" data-aos-duration="1000" className='research-framework w-full max-w-screen-min-screen'>
          <h2 className='text-primary-dark metro-semi uppercase mb-4'>Research Framework</h2>
          <p className='text-[19px] lg:text-[21px] text-secondary-light metro leading-relaxed mb-4'>
            QLab develops systematic research infrastructure designed to study market behavior at multiple time scales.
            Signals are evaluated through statistical validation, out-of-sample testing, and controlled execution environments before deployment.
          </p>
          <p className='text-[19px] lg:text-[21px] text-secondary-light metro leading-relaxed'>
            The research program integrates signal discovery, execution modeling, and portfolio risk controls into a unified framework for systematic strategy development.
          </p>
        </div>
      </div>
    </>
  )
}

export default WhatWeDo
